import { GLOBAL_CONSTANTS } from '@/constants/globalConstants'
import {
  MTRouteTab,
  MTSharedRouteTabsProps,
} from '@/multi-territory/mt-types/mt-shared'
import { NavLink } from 'react-router'

const getTabClasses = (isActive: boolean): string => {
  const base =
    'px-4 h-[39px] flex items-center justify-center text-[16px] font-medium leading-[1.4em] cursor-pointer whitespace-nowrap transition-colors text-center box-border border-b-[4px] mb-[-1px]'
  const activeStyles =
    'text-[var(--forbrand-primary)] border-b-[var(--forbrand-color)]'
  const inactiveStyles = 'text-[var(--forbrand-secondary)] border-b-transparent'

  return `${base} ${isActive ? activeStyles : inactiveStyles}`
}

const renderTab = (tab: MTRouteTab): React.ReactNode => {
  return (
    <NavLink
      key={tab.id}
      to={tab.route}
      className={({ isActive }) => getTabClasses(isActive)}
      aria-label={`${GLOBAL_CONSTANTS.MT_NAVIGATE_TO} ${tab.displayName}`}
    >
      {tab.displayName}
    </NavLink>
  )
}

export function MTSharedRouteTabs({ tabs }: MTSharedRouteTabsProps) {
  return (
    <nav
      className="relative flex flex-row items-end w-full overflow-x-auto hide-scrollbar border-b border-b-[var(--border-strong)]"
      aria-label={GLOBAL_CONSTANTS.MT_TAB_NAVIGATION_LABEL}
    >
      {tabs.map(renderTab)}
    </nav>
  )
}
